module.exports = __webpack_public_path__ + "img/contamination-details.25f6628e.svg";